/**
 * Build a validated Vimeo embed URL from a user-provided Vimeo URL.
 *
 * @param {string} url Vimeo URL.
 * @returns {string|null} Safe embed URL or null.
 */
export function getSafeVimeoEmbedUrl(url) {
  try {
    const parsed = new URL(url, window.location.origin);
    const allowedHosts = new Set([
      "vimeo.com",
      "www.vimeo.com",
      "player.vimeo.com",
    ]);

    if (!allowedHosts.has(parsed.hostname)) {
      return null;
    }

    let videoId = "";
    if (parsed.hostname === "player.vimeo.com") {
      const parts = parsed.pathname.split("/").filter(Boolean);
      videoId = parts[0] === "video" ? parts[1] || "" : "";
    } else {
      const parts = parsed.pathname.split("/").filter(Boolean);
      videoId = parts[parts.length - 1] || "";
    }

    if (!/^\d+$/.test(videoId)) {
      return null;
    }

    const params = new URLSearchParams({
      autoplay: "1",
      playsinline: "1",
      title: "0",
      byline: "0",
      portrait: "0",
      badge: "0",
      dnt: "1",
      autopause: "0",
    });

    return `https://player.vimeo.com/video/${videoId}?${params.toString()}`;
  } catch (error) {
    return null;
  }
}
